import React, { useMemo } from "react";
import style from "../../index.module.scss";
import { Can } from "../../../../../../service/service";
import { SourceItem } from "../../../../../../pages/ResourcePool/service";
import classNames from "classnames";
import { LearnDataProps } from "../../../../../../service/CourseDetail/resource";
import { CourseWareTypeList } from "../../../../../../utils/common";

interface Props {
    source: SourceItem | LearnDataProps;
    children?: React.ReactChild;
    className?: string;
}
const Index = ({ source, children, className }: Props) => {
    type keyType = keyof typeof CourseWareTypeList;
    const fileType = useMemo((): string => {
        for (let type of Object.keys(CourseWareTypeList)) {
            if (
                CourseWareTypeList[type as keyType].includes(
                    source?.sourceFileEntity?.fileType?.toLowerCase() || ""
                )
            ) {
                return type;
            }
        }
        return "";
    }, []);

    return (
        <div>
            <div className={classNames(style.info, className || "")}>
                {children}
                {!["href", "polyv"].includes(fileType) && (
                    <>
                        <span>大小 {source?.sourceFileEntity?.fileSize}</span>
                        <span>
                            {source?.isDownload === Can.yes ? "允许" : "禁止"}
                            下载
                        </span>
                        <span>
                            {"description" in source ? source?.description : ""}
                        </span>
                    </>
                )}
                {["href"].includes(fileType) && (
                    <span>网页地址 {source?.sourceFileEntity?.viewUrl}</span>
                )}
            </div>
        </div>
    );
};

export default Index;
